"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MultiSelect = function MultiSelect(_ref) {
  var className = _ref.className,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["className", "size"]);

  var wrapperClass = 'multi-select-wrapper';
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", {
    className: wrapperClass
  }, _react.default.createElement(_reactSelect.default, _extends({}, props, {
    styles: size === 'small' ? smallStyles : defaultStyles
  })));
};
/* istanbul ignore next */


var defaultStyles = {
  control: function control(styles) {
    return _objectSpread({}, styles, {
      minHeight: '60px',
      border: '1px solid #c2c2c2',
      boxShadow: 'none',
      ':hover': {
        borderColor: '#47baec'
      }
    });
  },
  multiValueLabel: function multiValueLabel(styles) {
    return _objectSpread({}, styles, {
      fontSize: '18px',
      fontFamily: 'Roboto, sans-serif',
      padding: '13px'
    });
  },
  singleValue: function singleValue(styles) {
    return _objectSpread({}, styles, {
      fontSize: '18px',
      fontFamily: 'Roboto, sans-serif',
      padding: '13px'
    });
  },
  option: function option(styles) {
    return _objectSpread({}, styles, {
      fontFamily: 'Roboto, sans-serif'
    });
  },
  placeholder: function placeholder(styles) {
    return _objectSpread({}, styles, {
      fontSize: '18px',
      fontFamily: 'Roboto, sans-serif'
    });
  }
};
var smallStyles = {
  control:
  /* istanbul ignore next */
  function control(styles) {
    return _objectSpread({}, styles, {
      border: '1px solid #c2c2c2',
      boxShadow: 'none',
      ':hover': {
        borderColor: '#47baec'
      }
    });
  },
  multiValueLabel:
  /* istanbul ignore next */
  function multiValueLabel(styles) {
    return _objectSpread({}, styles, {
      fontSize: '14px',
      fontFamily: 'Roboto, sans-serif'
    });
  },
  singleValue:
  /* istanbul ignore next */
  function singleValue(styles) {
    return _objectSpread({}, styles, {
      fontSize: '14px',
      fontFamily: 'Roboto, sans-serif'
    });
  },
  option:
  /* istanbul ignore next */
  function option(styles) {
    return _objectSpread({}, styles, {
      fontFamily: 'Roboto, sans-serif'
    });
  },
  placeholder:
  /* istanbul ignore next */
  function placeholder(styles) {
    return _objectSpread({}, styles, {
      fontSize: '14px',
      fontFamily: 'Roboto, sans-serif'
    });
  }
};
var _default = MultiSelect;
exports.default = _default;